// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ProtectedRouteRouteImport } from './routes/_protected/route'
import { Route as ProtectedIndexRouteImport } from './routes/_protected/index'
import { Route as ProtectedStudentTasksIndexRouteImport } from './routes/_protected/student-tasks/index'
import { Route as ProtectedStudentFeedbackIndexRouteImport } from './routes/_protected/student-feedback/index'
import { Route as ProtectedSitesIndexRouteImport } from './routes/_protected/sites/index'
import { Route as ProtectedReviewCourseIndexRouteImport } from './routes/_protected/review-course/index'
import { Route as ProtectedOperationGuideIndexRouteImport } from './routes/_protected/operation-guide/index'
import { Route as ProtectedKnowledgeIndexRouteImport } from './routes/_protected/knowledge/index'
import { Route as ProtectedDesignTemplatesIndexRouteImport } from './routes/_protected/design-templates/index'
import { Route as ProtectedSiteToolsLayoutRouteImport } from './routes/_protected/site-tools/_layout'
import { Route as ProtectedSioToolsLayoutRouteImport } from './routes/_protected/sio-tools/_layout'
import { Route as ProtectedKnowledgeTagsRouteImport } from './routes/_protected/knowledge/tags'
import { Route as ProtectedKnowledgeReviewRouteImport } from './routes/_protected/knowledge/review'
import { Route as ProtectedKnowledgePoolRouteImport } from './routes/_protected/knowledge/pool'
import { Route as ProtectedKnowledgeDraftsRouteImport } from './routes/_protected/knowledge/drafts'
import { Route as ProtectedDesignTemplatesIdRouteImport } from './routes/_protected/design-templates/$id'
import { Route as ClassProgressClassSessionIdGroupIdIndexRouteImport } from './routes/class-progress/$classSessionId.$groupId/index'
import { Route as ProtectedReviewCourseAdminIndexRouteImport } from './routes/_protected/review-course/admin/index'
import { Route as ProtectedReviewCourseCourseIdIndexRouteImport } from './routes/_protected/review-course/$courseId/index'
import { Route as ProtectedKnowledgeArticlesIndexRouteImport } from './routes/_protected/knowledge/articles/index'
import { Route as ProtectedKnowledgeEditIdRouteImport } from './routes/_protected/knowledge/edit/$id'
import { Route as ProtectedKnowledgeArticlesIdRouteImport } from './routes/_protected/knowledge/articles/$id'
import { Route as ProtectedSiteToolsLayoutIndexRouteImport } from './routes/_protected/site-tools/_layout/index'
import { Route as ProtectedSiteToolsLayoutSettingsRouteImport } from './routes/_protected/site-tools/_layout/settings'
import { Route as ProtectedSioToolsLayoutIndexRouteImport } from './routes/_protected/sio-tools/_layout/index'
import { Route as ProtectedSioToolsLayoutSettingsRouteImport } from './routes/_protected/sio-tools/_layout/settings'
import { Route as ProtectedSiteToolsLayoutReferencesIndexRouteImport } from './routes/_protected/site-tools/_layout/references/index'
import { Route as ProtectedSiteToolsLayoutAcfIndexRouteImport } from './routes/_protected/site-tools/_layout/acf/index'
import { Route as ProtectedSiteToolsLayoutReferencesIdRouteImport } from './routes/_protected/site-tools/_layout/references/$id'
import { Route as ProtectedSioToolsLayoutTopicsIndexRouteImport } from './routes/_protected/sio-tools/_layout/topics/index'
import { Route as ProtectedSioToolsLayoutPipelineIndexRouteImport } from './routes/_protected/sio-tools/_layout/pipeline/index'
import { Route as ProtectedSioToolsLayoutKeywordsIndexRouteImport } from './routes/_protected/sio-tools/_layout/keywords/index'
import { Route as ProtectedSioToolsLayoutInsightIndexRouteImport } from './routes/_protected/sio-tools/_layout/insight/index'
import { Route as ProtectedSioToolsLayoutExternalLinksIndexRouteImport } from './routes/_protected/sio-tools/_layout/external-links/index'
import { Route as ProtectedSioToolsLayoutBlogIndexRouteImport } from './routes/_protected/sio-tools/_layout/blog/index'
import { Route as ProtectedSioToolsLayoutAdsIndexRouteImport } from './routes/_protected/sio-tools/_layout/ads/index'

const ProtectedSiteToolsRouteImport = createFileRoute('/_protected/site-tools')()
const ProtectedSioToolsRouteImport = createFileRoute('/_protected/sio-tools')()

const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const ProtectedRouteRoute = ProtectedRouteRouteImport.update({
            id: '/_protected',getParentRoute: () => rootRouteImport
          })
const ProtectedSiteToolsRoute = ProtectedSiteToolsRouteImport.update({
            id: '/site-tools',path: '/site-tools',getParentRoute: () => ProtectedRouteRoute
          })
const ProtectedSioToolsRoute = ProtectedSioToolsRouteImport.update({
            id: '/sio-tools',path: '/sio-tools',getParentRoute: () => ProtectedRouteRoute
          })
const ProtectedIndexRoute = ProtectedIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ProtectedRouteRoute
          })
const ProtectedStudentTasksIndexRoute = ProtectedStudentTasksIndexRouteImport.update({
            id: '/student-tasks/',path: '/student-tasks/',getParentRoute: () => ProtectedRouteRoute
          })
const ProtectedStudentFeedbackIndexRoute = ProtectedStudentFeedbackIndexRouteImport.update({
            id: '/student-feedback/',path: '/student-feedback/',getParentRoute: () => ProtectedRouteRoute
          })
const ProtectedSitesIndexRoute = ProtectedSitesIndexRouteImport.update({
            id: '/sites/',path: '/sites/',getParentRoute: () => ProtectedRouteRoute
          })
const ProtectedReviewCourseIndexRoute = ProtectedReviewCourseIndexRouteImport.update({
            id: '/review-course/',path: '/review-course/',getParentRoute: () => ProtectedRouteRoute
          })
const ProtectedOperationGuideIndexRoute = ProtectedOperationGuideIndexRouteImport.update({
            id: '/operation-guide/',path: '/operation-guide/',getParentRoute: () => ProtectedRouteRoute
          })
const ProtectedKnowledgeIndexRoute = ProtectedKnowledgeIndexRouteImport.update({
            id: '/knowledge/',path: '/knowledge/',getParentRoute: () => ProtectedRouteRoute
          })
const ProtectedDesignTemplatesIndexRoute = ProtectedDesignTemplatesIndexRouteImport.update({
            id: '/design-templates/',path: '/design-templates/',getParentRoute: () => ProtectedRouteRoute
          })
const ProtectedSiteToolsLayoutRoute = ProtectedSiteToolsLayoutRouteImport.update({
            id: '/_layout',getParentRoute: () => ProtectedSiteToolsRoute
          })
const ProtectedSioToolsLayoutRoute = ProtectedSioToolsLayoutRouteImport.update({
            id: '/_layout',getParentRoute: () => ProtectedSioToolsRoute
          })
const ProtectedKnowledgeTagsRoute = ProtectedKnowledgeTagsRouteImport.update({
            id: '/knowledge/tags',path: '/knowledge/tags',getParentRoute: () => ProtectedRouteRoute
          })
const ProtectedKnowledgeReviewRoute = ProtectedKnowledgeReviewRouteImport.update({
            id: '/knowledge/review',path: '/knowledge/review',getParentRoute: () => ProtectedRouteRoute
          })
const ProtectedKnowledgePoolRoute = ProtectedKnowledgePoolRouteImport.update({
            id: '/knowledge/pool',path: '/knowledge/pool',getParentRoute: () => ProtectedRouteRoute
          })
const ProtectedKnowledgeDraftsRoute = ProtectedKnowledgeDraftsRouteImport.update({
            id: '/knowledge/drafts',path: '/knowledge/drafts',getParentRoute: () => ProtectedRouteRoute
          })
const ProtectedDesignTemplatesIdRoute = ProtectedDesignTemplatesIdRouteImport.update({
            id: '/design-templates/$id',path: '/design-templates/$id',getParentRoute: () => ProtectedRouteRoute
          })
const ClassProgressClassSessionIdGroupIdIndexRoute = ClassProgressClassSessionIdGroupIdIndexRouteImport.update({
            id: '/class-progress/$classSessionId/$groupId/',path: '/class-progress/$classSessionId/$groupId/',getParentRoute: () => rootRouteImport
          })
const ProtectedReviewCourseAdminIndexRoute = ProtectedReviewCourseAdminIndexRouteImport.update({
            id: '/review-course/admin/',path: '/review-course/admin/',getParentRoute: () => ProtectedRouteRoute
          })
const ProtectedReviewCourseCourseIdIndexRoute = ProtectedReviewCourseCourseIdIndexRouteImport.update({
            id: '/review-course/$courseId/',path: '/review-course/$courseId/',getParentRoute: () => ProtectedRouteRoute
          })
const ProtectedKnowledgeArticlesIndexRoute = ProtectedKnowledgeArticlesIndexRouteImport.update({
            id: '/knowledge/articles/',path: '/knowledge/articles/',getParentRoute: () => ProtectedRouteRoute
          })
const ProtectedKnowledgeEditIdRoute = ProtectedKnowledgeEditIdRouteImport.update({
            id: '/knowledge/edit/$id',path: '/knowledge/edit/$id',getParentRoute: () => ProtectedRouteRoute
          })
const ProtectedKnowledgeArticlesIdRoute = ProtectedKnowledgeArticlesIdRouteImport.update({
            id: '/knowledge/articles/$id',path: '/knowledge/articles/$id',getParentRoute: () => ProtectedRouteRoute
          })
const ProtectedSiteToolsLayoutIndexRoute = ProtectedSiteToolsLayoutIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ProtectedSiteToolsLayoutRoute
          })
const ProtectedSiteToolsLayoutSettingsRoute = ProtectedSiteToolsLayoutSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => ProtectedSiteToolsLayoutRoute
          })
const ProtectedSioToolsLayoutIndexRoute = ProtectedSioToolsLayoutIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ProtectedSioToolsLayoutRoute
          })
const ProtectedSioToolsLayoutSettingsRoute = ProtectedSioToolsLayoutSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => ProtectedSioToolsLayoutRoute
          })
const ProtectedSiteToolsLayoutReferencesIndexRoute = ProtectedSiteToolsLayoutReferencesIndexRouteImport.update({
            id: '/references/',path: '/references/',getParentRoute: () => ProtectedSiteToolsLayoutRoute
          })
const ProtectedSiteToolsLayoutAcfIndexRoute = ProtectedSiteToolsLayoutAcfIndexRouteImport.update({
            id: '/acf/',path: '/acf/',getParentRoute: () => ProtectedSiteToolsLayoutRoute
          })
const ProtectedSiteToolsLayoutReferencesIdRoute = ProtectedSiteToolsLayoutReferencesIdRouteImport.update({
            id: '/references/$id',path: '/references/$id',getParentRoute: () => ProtectedSiteToolsLayoutRoute
          })
const ProtectedSioToolsLayoutTopicsIndexRoute = ProtectedSioToolsLayoutTopicsIndexRouteImport.update({
            id: '/topics/',path: '/topics/',getParentRoute: () => ProtectedSioToolsLayoutRoute
          })
const ProtectedSioToolsLayoutPipelineIndexRoute = ProtectedSioToolsLayoutPipelineIndexRouteImport.update({
            id: '/pipeline/',path: '/pipeline/',getParentRoute: () => ProtectedSioToolsLayoutRoute
          })
const ProtectedSioToolsLayoutKeywordsIndexRoute = ProtectedSioToolsLayoutKeywordsIndexRouteImport.update({
            id: '/keywords/',path: '/keywords/',getParentRoute: () => ProtectedSioToolsLayoutRoute
          })
const ProtectedSioToolsLayoutInsightIndexRoute = ProtectedSioToolsLayoutInsightIndexRouteImport.update({
            id: '/insight/',path: '/insight/',getParentRoute: () => ProtectedSioToolsLayoutRoute
          })
const ProtectedSioToolsLayoutExternalLinksIndexRoute = ProtectedSioToolsLayoutExternalLinksIndexRouteImport.update({
            id: '/external-links/',path: '/external-links/',getParentRoute: () => ProtectedSioToolsLayoutRoute
          })
const ProtectedSioToolsLayoutBlogIndexRoute = ProtectedSioToolsLayoutBlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => ProtectedSioToolsLayoutRoute
          })
const ProtectedSioToolsLayoutAdsIndexRoute = ProtectedSioToolsLayoutAdsIndexRouteImport.update({
            id: '/ads/',path: '/ads/',getParentRoute: () => ProtectedSioToolsLayoutRoute
          })





const ProtectedSioToolsLayoutRouteChildren = {
  ProtectedSioToolsLayoutSettingsRoute: ProtectedSioToolsLayoutSettingsRoute,ProtectedSioToolsLayoutIndexRoute: ProtectedSioToolsLayoutIndexRoute,ProtectedSioToolsLayoutAdsIndexRoute: ProtectedSioToolsLayoutAdsIndexRoute,ProtectedSioToolsLayoutBlogIndexRoute: ProtectedSioToolsLayoutBlogIndexRoute,ProtectedSioToolsLayoutExternalLinksIndexRoute: ProtectedSioToolsLayoutExternalLinksIndexRoute,ProtectedSioToolsLayoutInsightIndexRoute: ProtectedSioToolsLayoutInsightIndexRoute,ProtectedSioToolsLayoutKeywordsIndexRoute: ProtectedSioToolsLayoutKeywordsIndexRoute,ProtectedSioToolsLayoutPipelineIndexRoute: ProtectedSioToolsLayoutPipelineIndexRoute,ProtectedSioToolsLayoutTopicsIndexRoute: ProtectedSioToolsLayoutTopicsIndexRoute
}

const ProtectedSioToolsLayoutRouteWithChildren = ProtectedSioToolsLayoutRoute._addFileChildren(ProtectedSioToolsLayoutRouteChildren)



const ProtectedSioToolsRouteChildren = {
  ProtectedSioToolsLayoutRoute: ProtectedSioToolsLayoutRouteWithChildren
}

const ProtectedSioToolsRouteWithChildren = ProtectedSioToolsRoute._addFileChildren(ProtectedSioToolsRouteChildren)




const ProtectedSiteToolsLayoutRouteChildren = {
  ProtectedSiteToolsLayoutSettingsRoute: ProtectedSiteToolsLayoutSettingsRoute,ProtectedSiteToolsLayoutIndexRoute: ProtectedSiteToolsLayoutIndexRoute,ProtectedSiteToolsLayoutReferencesIdRoute: ProtectedSiteToolsLayoutReferencesIdRoute,ProtectedSiteToolsLayoutAcfIndexRoute: ProtectedSiteToolsLayoutAcfIndexRoute,ProtectedSiteToolsLayoutReferencesIndexRoute: ProtectedSiteToolsLayoutReferencesIndexRoute
}

const ProtectedSiteToolsLayoutRouteWithChildren = ProtectedSiteToolsLayoutRoute._addFileChildren(ProtectedSiteToolsLayoutRouteChildren)



const ProtectedSiteToolsRouteChildren = {
  ProtectedSiteToolsLayoutRoute: ProtectedSiteToolsLayoutRouteWithChildren
}

const ProtectedSiteToolsRouteWithChildren = ProtectedSiteToolsRoute._addFileChildren(ProtectedSiteToolsRouteChildren)



const ProtectedRouteRouteChildren = {
  ProtectedIndexRoute: ProtectedIndexRoute,ProtectedDesignTemplatesIdRoute: ProtectedDesignTemplatesIdRoute,ProtectedKnowledgeDraftsRoute: ProtectedKnowledgeDraftsRoute,ProtectedKnowledgePoolRoute: ProtectedKnowledgePoolRoute,ProtectedKnowledgeReviewRoute: ProtectedKnowledgeReviewRoute,ProtectedKnowledgeTagsRoute: ProtectedKnowledgeTagsRoute,ProtectedSioToolsRoute: ProtectedSioToolsRouteWithChildren,ProtectedSiteToolsRoute: ProtectedSiteToolsRouteWithChildren,ProtectedDesignTemplatesIndexRoute: ProtectedDesignTemplatesIndexRoute,ProtectedKnowledgeIndexRoute: ProtectedKnowledgeIndexRoute,ProtectedOperationGuideIndexRoute: ProtectedOperationGuideIndexRoute,ProtectedReviewCourseIndexRoute: ProtectedReviewCourseIndexRoute,ProtectedSitesIndexRoute: ProtectedSitesIndexRoute,ProtectedStudentFeedbackIndexRoute: ProtectedStudentFeedbackIndexRoute,ProtectedStudentTasksIndexRoute: ProtectedStudentTasksIndexRoute,ProtectedKnowledgeArticlesIdRoute: ProtectedKnowledgeArticlesIdRoute,ProtectedKnowledgeEditIdRoute: ProtectedKnowledgeEditIdRoute,ProtectedKnowledgeArticlesIndexRoute: ProtectedKnowledgeArticlesIndexRoute,ProtectedReviewCourseCourseIdIndexRoute: ProtectedReviewCourseCourseIdIndexRoute,ProtectedReviewCourseAdminIndexRoute: ProtectedReviewCourseAdminIndexRoute
}

const ProtectedRouteRouteWithChildren = ProtectedRouteRoute._addFileChildren(ProtectedRouteRouteChildren)

const rootRouteChildren = {
  ProtectedRouteRoute: ProtectedRouteRouteWithChildren,LoginRoute: LoginRoute,ClassProgressClassSessionIdGroupIdIndexRoute: ClassProgressClassSessionIdGroupIdIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)